import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import { message } from 'antd';
import { concat, filter, findIndex, some, trim } from 'lodash';
import { asyncSimpleModal, getDifferenceList, reOrderArray } from '../../lib/common';
import { brandActions } from '../../store/modules/brand';
import BrandExposureWrap from '../../views/brand/exposure/BrandExposureWrap/BrandExposureWrap';
import {
  BRAND_EXPOSURE_LIST_STATUS,
  BRAND_EXPOSURE_STATUS_INDEX_JSON,
  BRAND_PAGE_TYPE,
  BRAND_TIER_LIST_STATUS,
} from '../../constants/service/app/brandConstants';
import { BRAND_EXPOSURE_SELECTOR_FILTER_OPTION_MODEL } from '../../store/modules/brand/models';

class BrandExposureContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { getBrandExposureInfo, pageType } = this.props;

    getBrandExposureInfo({
      filterOption: BRAND_EXPOSURE_SELECTOR_FILTER_OPTION_MODEL,
      tableType: pageType,
    });
  }

  /**
   *
   * **************************************
   *
   * 브랜드 노출관리 리스트에서 사용하는 액션들
   *
   * ***************************************
   */

  /**
   * 초기화
   */
  resetBrandExposureInfo = () => {
    const { brandExposureList, setData } = this.props;
    const { originList } = brandExposureList;

    /**
     * 노출된 브랜드 목록 초기화
     */
    setData({
      path: ['brandExposureList', 'newList'],
      /**
       *  기존 브랜드 리스트로 초기화하되 상태값을 '기본'값으로 넣어준다
       */
      value: originList.map((item) => ({ ...item, listStatus: BRAND_EXPOSURE_LIST_STATUS.NORMAL })),
    });

    /**
     *  노출되고 있지 않은 매장 검색 체크박스 해제
     */
    setData({
      path: ['brandExposureSelector', 'filterOption', 'isSearchInActive'],
      value: false,
    });

    /**
     *  노출되고 있는 매장 검색 체크박스 해제
     */
    setData({
      path: ['brandExposureSelector', 'filterOption', 'isSearchActive'],
      value: false,
    });

    /**
     *  검색된 브랜드 선택 값 초기화
     */
    setData({
      path: ['brandExposureSelector', 'selectedList'],
      value: [],
    });
  };

  /**
   * 스크롤 이동
   */
  scrollToBrandElement = (no) => {
    scroller.scrollTo(`no_${no}`, {
      duration: 1500,
      delay: 100,
      smooth: true,
      containerId: 'store-exposure-list-scroll',
      offset: -250,
    });
  };

  /**
   * 브랜드 상태에 따라 순서 초기화
   */
  resetBrandExposureListNo = (exposureList) => {
    let resetOrderedNo = 0;

    return exposureList.map((item) => {
      /**
       * 삭제 상태인 브랜드는 순번을 0으로 하고
       */
      if (item.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED) {
        return {
          ...item,
          no: 0,
        };
      } else {
        /**
         * 나머지 브랜드끼리 순번을 정한다
         */
        resetOrderedNo++;

        return {
          ...item,
          no: resetOrderedNo,
        };
      }
    });
  };

  /**
   * 브랜드 수정 상태 변경
   */
  updateExposureListStatus = (exposureList) => {
    const { brandExposureList } = this.props;
    const { originList } = brandExposureList;

    /**
     * 기존 리스트와 비교
     */
    return exposureList.map((item) => {
      let listStatus = item.listStatus;

      /**
       *  새롭게 추가된 브랜드와 삭제된 브랜드는 상태를 변경하지 않는다.
       */
      if (
        item.listStatus === BRAND_EXPOSURE_LIST_STATUS.NORMAL ||
        item.listStatus === BRAND_EXPOSURE_LIST_STATUS.MODIFIED
      ) {
        /**
         *  기존 브랜드 인덱스
         */
        const originItemIndex = findIndex(originList, ['storeId', item.storeId]);

        /**
         *  기존 브랜드
         */
        const originItem = originList[originItemIndex];

        /**
         *  기존 브랜드와 순서와 노출여부가 모두 같으면 기본 상태로 판단한다.
         */
        if (item.no === originItem.no && item.status === originItem.status) {
          listStatus = BRAND_TIER_LIST_STATUS.NORMAL;
        } else {
          /**
           *  하나라도 다르면 수정상태이다
           */
          listStatus = BRAND_EXPOSURE_LIST_STATUS.MODIFIED;
        }
      }

      return {
        ...item,
        listStatus,
      };
    });
  };

  /**
   * 노출 여부 변경
   */
  changeExposureStatus = async (index, checked) => {
    const { brandExposureList, pageType, setData } = this.props;
    const { originList, newList } = brandExposureList;

    /**
     * 썸네일 유무 판단해서 없으면 노출 활성화를 하지 않는다.
     */
    /**
     *  현재 브랜드 정보
     */
    const currentItem = newList[index];

    /**
     *  썸네일이 없는 경우 alert 뜨고 리턴
     */
    if (!currentItem.url) {
      await asyncSimpleModal({
        type: 'error',
        title: '노출 여부 업데이트',
        message: '해당 브랜드는 썸네일이 없어 노출이 불가능합니다.',
      });
      return;
    }

    /**
     * 상단 노출 관리 페이지 인 경우 노출 브랜드를 4개로 제한한다.
     */
    const currentExposureList = filter(newList, (item) => item.status === BRAND_EXPOSURE_STATUS_INDEX_JSON.ACTIVE);
    if (pageType === BRAND_PAGE_TYPE.TOP_EXPOSURE && checked && currentExposureList.length >= 4) {
      await asyncSimpleModal({
        type: 'error',
        title: '노출 여부 업데이트',
        message: '상단노출되는 브랜드는 4개로 제한됩니다!',
      });
      return;
    }

    /**
     * 노출 관리 페이지 인 경우 서브 이미지가 없으면 노출하지 않는다.
     */
    if (pageType === BRAND_PAGE_TYPE.EXPOSURE && checked && !currentItem.isExistSubImg) {
      await asyncSimpleModal({
        type: 'error',
        title: '노출 여부 업데이트',
        message: '해당 브랜드는 서브 이미지가 없어 노출이 불가능합니다!',
      });
      return;
    }

    /**
     * 노출 여부를 변경하고
     */
    /**
     *  노출 여부 값
     */
    const exposureStatus = checked
      ? BRAND_EXPOSURE_STATUS_INDEX_JSON.ACTIVE
      : BRAND_EXPOSURE_STATUS_INDEX_JSON.IN_ACTIVE;

    /**
     *  노출 여부 변경
     */
    setData({
      path: ['brandExposureList', 'newList', index, 'status'],
      value: exposureStatus,
    });

    /**
     * 브랜드의 상태를 변경한다.
     */
    /**
     *  새롭게 추가된 브랜드는 노출 여부를 바꿔도 상태를 바꾸지 않는다.
     */
    if (currentItem.listStatus !== BRAND_EXPOSURE_LIST_STATUS.ADDED) {
      /**
       *  기존 브랜드 인덱스
       */
      const originItemIndex = findIndex(originList, ['storeId', currentItem.storeId]);

      /**
       *  기존 브랜드
       */
      const originItem = originList[originItemIndex];

      /**
       *  브랜드의 상태
       */
      let listStatus;

      /**
       *  기존 브랜드와 노출여부와 순서가 모두 동일한 경우 normal 상태이고
       */
      if (exposureStatus === originItem.status && originItem.storeId === currentItem.storeId) {
        listStatus = BRAND_EXPOSURE_LIST_STATUS.NORMAL;
      } else {
        /**
         *  하나라도 다르면 수정 상태이다.
         */
        listStatus = BRAND_EXPOSURE_LIST_STATUS.MODIFIED;
      }

      /**
       *  listStatus 변경
       */
      setData({
        path: ['brandExposureList', 'newList', index, 'listStatus'],
        value: listStatus,
      });
    }
  };

  /**
   * dnd로 순서변경
   */
  changeNumberOnDragEnd = (result) => {
    const { source, destination } = result;

    if (!source || !destination) return;

    this.changeNumberOnBrandTierList(source.index, destination.index);
  };

  /**
   * input 으로 순서 변경
   */
  changeNumberOnBrandTierList = (sourceIndex, destinationIndex) => {
    const { brandExposureList, setData } = this.props;
    const { newList } = brandExposureList;

    /**
     *  브랜드 티어 리스트의 순서를 바꾸고
     */
    const reOrderedList = reOrderArray(newList, sourceIndex, destinationIndex);

    /**
     *  상태에 따라 순번을 초기화하고
     */
    const resetList = this.resetBrandExposureListNo(reOrderedList);

    /**
     *  나머지 브랜드의 상태를 결정한다.
     */
    const resultList = this.updateExposureListStatus(resetList);

    /**
     *  새로운 브랜드 티어 리스트를 반환한다.
     */
    setData({
      path: ['brandExposureList', 'newList'],
      value: resultList,
    });
  };

  /**
   * 브랜드 노출순서 관리 목록에서 삭제
   */
  deleteBrandExposureItem = (tier, storeId) => {
    const { brandExposureList, setData } = this.props;
    const { newList } = brandExposureList;

    /**
     *  삭제하려는 브랜드 인덱스
     */
    const brandIndex = findIndex(newList, ['storeId', storeId]);
    /**
     *  삭제하려는 브랜드 정보
     */
    const brandInfo = newList[brandIndex];

    /**
     *  삭제한 브랜드 리스트
     */
    let updatedList = [];

    /**
     *  새롭게 추가된 경우 목록에서 삭제한다.
     */
    if (brandInfo.listStatus === BRAND_EXPOSURE_LIST_STATUS.ADDED) {
      updatedList = filter(newList, (item) => item.no !== brandInfo.no);
    } else if (brandInfo.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED) {
      /**
       *  삭제취소를 하는 경우
       */
      updatedList = newList.map((item) => {
        let listStatus = item.listStatus;

        if (item.storeId === storeId) listStatus = BRAND_EXPOSURE_LIST_STATUS.NORMAL;

        return { ...item, listStatus };
      });
    } else {
      /**
       *  삭제상태로 만드는 경우
       */
      updatedList = newList.map((item) => {
        let editedNumber = item.no;
        let listStatus = item.listStatus;
        let exposureStatus = item.status;

        /**
         *  삭제한 브랜드만 삭제 상태로 만들고
         */
        if (item.storeId === storeId) {
          editedNumber = 0;
          listStatus = BRAND_TIER_LIST_STATUS.DELETED;
          exposureStatus = BRAND_EXPOSURE_STATUS_INDEX_JSON.IN_ACTIVE;
        }

        return {
          ...item,
          no: editedNumber,
          listStatus,
          status: exposureStatus,
        };
      });
    }

    /**
     *  상태에 따라 순번을 초기화하고
     */
    const resetList = this.resetBrandExposureListNo(updatedList);

    /**
     *  나머지 브랜드의 상태를 결정한다.
     */
    const resultList = this.updateExposureListStatus(resetList, tier);

    setData({
      path: ['brandExposureList', 'newList'],
      value: resultList,
    });
  };

  /**
   * **************************************
   *
   * 브랜드 노출관리 셀렉터에서 사용하는 액션들
   *
   * **************************************
   */

  /**
   * 노출 셀렉터 검색
   */
  searchBrandExposureSelectorList = () => {
    const { brandExposureSelector, pageType, getBrandExposureSelectorList } = this.props;
    const { filterOption } = brandExposureSelector;
    const { storeName, isSearch } = filterOption;
    const { inActive, active } = isSearch;

    /**
     * 브랜드 명을 입력하지 않으면 검색이 되지 않게 함
     */
    if (!(storeName && trim(storeName))) {
      message.error('브랜드명을 입력하세요');
      return;
    }

    /**
     * 매장의 노출 여부를 선택하지 않으면 검색이 되지 않게 함
     */
    if (!(inActive || active)) {
      message.error('노출 여부를 선택해주세요');
      return;
    }

    /**
     * 브랜드 검색
     */
    getBrandExposureSelectorList({
      filterOption: {
        storeName: trim(storeName),
        isSearch: {
          inActive,
          active,
        },
      },
      tableType: pageType,
    });
  };

  /**
   * 노출 셀렉터 초기화
   */
  resetBrandExposureSelectorList = () => {
    const { pageType, getBrandExposureSelectorList, setData } = this.props;

    /**
     *  셀렉터 목록 초기화
     */
    getBrandExposureSelectorList({
      filterOption: BRAND_EXPOSURE_SELECTOR_FILTER_OPTION_MODEL,
      tableType: pageType,
    });

    /**
     *  브랜드 셀렉터 선택 검색어
     */
    setData({
      path: ['brandExposureSelector', 'filterOption'],
      value: BRAND_EXPOSURE_SELECTOR_FILTER_OPTION_MODEL,
    });

    /**
     *  브랜드 셀렉터 선택값 초기화
     */
    setData({
      path: ['brandExposureSelector', 'selectedList'],
      value: [],
    });
  };

  /**
   * 선택 추가
   */
  addSelectedItemToList = () => {
    const { brandExposureList, brandExposureSelector, setData } = this.props;
    const { newList } = brandExposureList;
    const { selectedList, selectedTier } = brandExposureSelector;

    /**
     *  삭제상태인 브랜드의 수를 구하고
     */
    const deletedBrandCount = newList.filter((item) => item.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED).length;

    /**
     *  선택했던 브랜드 리스트를 더하고
     */
    const addedNewList = concat(newList, selectedList)
      /**
       *  티어, 순서를 추가한 후에 reducer 에 등록
       */
      .map((item, index) => {
        /**
         *  새로 추가되는 브랜드면 listStatus: added 추가
         */
        if (index > newList.length - 1) {
          return {
            ...item,
            tier: selectedTier,
            no: index - deletedBrandCount + 1,
            listStatus: BRAND_EXPOSURE_LIST_STATUS.ADDED,
            status: BRAND_EXPOSURE_STATUS_INDEX_JSON.IN_ACTIVE,
          };
        } else {
          return {
            ...item,
            tier: selectedTier,
          };
        }
      });

    setData({
      path: ['brandExposureList', 'newList'],
      value: addedNewList,
    });

    /**
     *  selectedList 에서 추가한 브랜드를 제외하고
     */
    const filteredSelectedList = getDifferenceList(selectedList, addedNewList, 'storeId', 'storeId');

    /**
     *  selectedList 로 덮어쓴다
     */
    setData({
      path: ['brandExposureSelector', 'selectedList'],
      value: filteredSelectedList,
    });

    /**
     *  해당 영역으로 스크롤 이동한다.
     */
    this.scrollToBrandElement(newList.length);
  };

  /**
   * 이미 노출관리 리스트에 있는지 중복 체크
   */
  checkIsDuplicateOnExposureList = (storeId) => {
    const { brandExposureList } = this.props;
    const { newList } = brandExposureList;

    /**
     *  storeId가 같은 요소가 있으면 true
     */
    return some(newList, ['storeId', storeId]);
  };

  /**
   * 셀렉터에서 선택/해제
   */
  selectSelectorItem = (checked, item) => {
    const { brandExposureSelector, setData } = this.props;
    const { selectedList } = brandExposureSelector;

    /**
     *  체크하면 리스트에 추가
     */
    if (checked) {
      setData({
        path: ['brandExposureSelector', 'selectedList', selectedList.length],
        value: item,
      });
    } else {
      /**
       *  체크를 풀면 리스트에서 삭제
       */
      setData({
        path: ['brandExposureSelector', 'selectedList'],
        value: filter(selectedList, (selectedItem) => selectedItem.storeId !== item.storeId),
      });
    }
  };

  /**
   * 셀렉터에서 리스트로 직접 추가
   */
  addBrandExposureListItem = (item) => {
    const { brandExposureList, brandExposureSelector, setData } = this.props;
    const { newList } = brandExposureList;
    const { selectedList } = brandExposureSelector;

    /**
     *  삭제상태인 브랜드의 수 구하고
     */
    const deletedBrandCount = newList.filter((item) => item.listStatus === BRAND_EXPOSURE_LIST_STATUS.DELETED).length;

    /**
     *  브랜드 리스트에 추가하고
     */
    setData({
      /**
       *  선택한 브랜드 목록에서 가장 마지막에 추가하며
       */
      path: ['brandExposureList', 'newList', newList.length],
      /**
       *  no를 리스트의 길이 - 삭제된 브랜드의 수 + 1로 맞춰주고
       */
      value: {
        ...item,
        no: newList.length + 1 - deletedBrandCount,
        listStatus: BRAND_EXPOSURE_LIST_STATUS.ADDED,
        status: BRAND_EXPOSURE_STATUS_INDEX_JSON.IN_ACTIVE,
      },
    });

    /**
     *  selectedList 에서 추가한 브랜드를 제외하고
     */
    const filteredSelectedList = selectedList.filter((selectedItem) => selectedItem.storeId !== item.storeId);

    /**
     *  selectedList 로 덮어쓴다
     */
    setData({
      path: ['brandExposureSelector', 'selectedList'],
      value: filteredSelectedList,
    });

    /**
     *  해당 영역으로 스크롤 이동한다.
     */
    this.scrollToBrandElement(newList.length);
  };

  render() {
    const { brandExposureList, brandExposureSelector, pageType, setData, editBrandExposureListRequest } = this.props;

    return (
      <BrandExposureWrap
        brandExposureList={brandExposureList}
        brandExposureSelector={brandExposureSelector}
        pageType={pageType}
        setData={setData}
        editBrandExposureListRequest={editBrandExposureListRequest}
        resetBrandExposureInfo={this.resetBrandExposureInfo}
        scrollToBrandElement={this.scrollToBrandElement}
        changeExposureStatus={this.changeExposureStatus}
        changeNumberOnDragEnd={this.changeNumberOnDragEnd}
        changeNumberOnBrandTierList={this.changeNumberOnBrandTierList}
        deleteBrandExposureItem={this.deleteBrandExposureItem}
        searchBrandExposureSelectorList={this.searchBrandExposureSelectorList}
        resetBrandExposureSelectorList={this.resetBrandExposureSelectorList}
        addBrandExposureListItem={this.addBrandExposureListItem}
        selectSelectorItem={this.selectSelectorItem}
        checkIsDuplicateOnExposureList={this.checkIsDuplicateOnExposureList}
        addSelectedItemToList={this.addSelectedItemToList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brandExposureList: state.brand.brandExposureList,
    brandExposureSelector: state.brand.brandExposureSelector,
  };
};

const mapDispatchToProps = {
  /**
   * [브랜드] 브랜드 페이지 데이터 변경하기
   */
  setData: brandActions.setData,
  /**
   * [브랜드] 브랜드 노출 리스트 정보 요청하기
   */
  getBrandExposureInfo: brandActions.getBrandExposureInfo,
  /**
   * [브랜드] 브랜드 노출 리스트 셀렉터 검색하기
   */
  getBrandExposureSelectorList: brandActions.getBrandExposureSelectorList,
  /**
   * [브랜드] 브랜드 노출 리스트 수정하기
   */
  editBrandExposureListRequest: brandActions.editBrandExposureListRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandExposureContainer);
